var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('MdmLink', {
    attrs: {
      "url": "/".concat(_vm.urlPrefix, "/e/legal/paiement"),
      "is-scramble-link": _vm.isScrambleLink
    }
  }, [_c('mdm-icon', {
    staticClass: "icon icon-item paiement_securise",
    attrs: {
      "name": "cadenas"
    }
  }), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('footer.secure_payment')))]), _vm._v("\n      " + _vm._s(_vm.bancontact) + _vm._s(_vm.paymentMethod) + "\n    ")])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };